import {useCallback, useRef} from 'react';

export const useSharedErrorHandler = (onError?: (error: Error) => void) => {
  const errorRef = useRef<Error>();
  return useCallback(
    (error: Error) => {
      if (!errorRef.current) {
        errorRef.current = error;
        if (onError) {
          onError(error);
          return undefined;
        }
        return error;
      }

      return undefined;
    },
    [onError],
  );
};
